module.exports = __webpack_public_path__ + "static/media/cba.222c2222.png";